module.exports = "<div style=\"margin-right: 20px; margin-left: 20px; margin-bottom: 20px;\">\r\n  <app-user-confirm-standard></app-user-confirm-standard>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/auth/signin/ex-notification-confirm-action/ex-notification-confirm-action.component.html
// module id = ../../../../../src/app/auth/signin/ex-notification-confirm-action/ex-notification-confirm-action.component.html
// module chunks = main